export const formatDate = (isoString) => {
    if (!isoString) return "";
  
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  };
  

 export const formatNumberWithCommas = (value) => {
    if (isNaN(value)) return value; // Return the input if it's not a number
    return Number(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };